(function($) {

  var pageId = 'page-message',
    page = '#' + pageId;

  $(function() {
    $('body')
      .on('ajax:beforeSend', page + ' .detail-action-del', beforeDelMsg)
      .on('ajax:complete', page + ' .detail-action-del', afterDelMsg);
  });

  function beforeDelMsg() {
    simple.loading({
      type: 'global',
      msg: '正在删除讨论...'
    });
  }

  function afterDelMsg() {
    simple.loading.destroy();
  }

  $(document).on('pjaxload#' + pageId, function(e, $page, page) {
    tower.adjustProjInfo();
    tower.adjustCommentsLike();
    tower.foldComments();
  });

})(jQuery);
